// Legacy /src/data/company.js — now a thin re-export from the SSOT JSON.
// Actual identity facts live in /app/frontend/data/company.json (PROMPT 3.6).
import ssot from "./company.json";
export const COMPANY = {
        legal_name: ssot.legal_name,
        gstin: ssot.gstin,
        cin: null,
        registered_address: `${ssot.address_line_1}, ${ssot.address_city}`,
        support_email: ssot.support_email,
        support_hours: ssot.operating_hours,
        response_promise: "within 24h",
};
